export default "__VITE_ASSET__a6w5Vcge__"